import React, { memo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";
import colors from "app/colors";
import { Text, VStack } from "@chakra-ui/react";

interface IProps {
  happycoWorkOrder: HappycoWorkOrderFragment;
}

const HappycoWorkOrderAssignee = ({ happycoWorkOrder }: IProps) => (
  <VStack spacing={0} alignItems="flex-start">
    <Text fontSize={12} fontWeight={500} color={colors.gray50}>
      Assigned To
    </Text>
    {happycoWorkOrder.assigneeName ? (
      <Text fontSize={14} fontWeight={700} color={colors.blackSecondary}>
        {happycoWorkOrder.assigneeName}
      </Text>
    ) : (
      <Text
        fontSize={14}
        fontWeight={500}
        color={colors.blackSecondary}
        fontStyle="italic"
      >
        Unassigned
      </Text>
    )}
  </VStack>
);

export default memo(HappycoWorkOrderAssignee);
